import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { ReportAbuseModal } from '../containers/modals/reportAbuseModal';
import { Constants } from '../../shared/utils/constants';
import { SignInModal } from '../../shared/components/modals/signInModal';
export function handleReportAbuseModalCall(appId, reviewId, reviewTitle, userInfo, reviewSource, dismissModal) {
    if (!userInfo.signedIn) {
        return /*#__PURE__*/ _jsx(SignInModal, {
            redirect: "reportAbuse",
            entityId: reviewId,
            reviewAppId: appId,
            reviewTitle: reviewTitle,
            dismissModal: dismissModal,
            signInModalType: Constants.SignInType.SignInWith_MSA_AAD
        });
    } else {
        return /*#__PURE__*/ _jsx(ReportAbuseModal, {
            appId: appId,
            reviewId: reviewId,
            reviewTitle: reviewTitle,
            reviewSource: reviewSource,
            dismissModal: dismissModal
        });
    }
}
